import { useNavigate } from "@tanstack/react-router";

import useCurrentLocation from "@/hooks/use-current-location";

import MobileBackButton, {
  type MobileBackButtonProps,
} from "./mobile-back-button";

export interface MobileExploreButtonProps extends MobileBackButtonProps {}

export default function MobileExploreButton(props: MobileExploreButtonProps) {
  const { toExploreUrl } = useCurrentLocation();
  const navigate = useNavigate();

  return (
    <MobileBackButton
      aria-label="Explore"
      onClick={() => navigate({ to: toExploreUrl() })}
      {...props}
    />
  );
}
